const {jQuery: $} = window;
import Utils from "./utils.class";
import InPageNav from "./inPageNav.class";

export default class Theme {
    $main;
    $html;
    $body;
    $header;
    #builder;
    #utils;
    #slider;
    #inPageNav;
    #config;
    #$wpAdmin;
    #scrollOffset;
    scrollSpeed;
    #$search;

    constructor(
        config,
        builder
    ) {
        this.#config = config;
        this.#builder = builder;
        this.#utils = new Utils();

        this.#scrollOffset = 0;
        this.scrollSpeed = 750;

        this.$html = $('html');
        this.$body = $('body');
        this.$main = $('.site-wrapper');
        this.$header = $('header.site_header');

        this.#inPageNav = new InPageNav(this);

        this.#$search = this.$header.find('.eyebrow__search_bar .search-button');

        if (window.location.hash == "#dev") {
            this.utils.cookies.set("debug", 1);
        }




        var top = 1; // Trigger on any scrolling

        $(document).scroll(function () {
            var scrollPos = $(document).scrollTop();
            if (top && scrollPos >= top) {
                $('.site_header').addClass('scrollColor');
            } else if (top && scrollPos < top) {
                $('.site_header').removeClass('scrollColor');
            }
        });
    }

    __onReady() {
        const me = this;

        this.#utils.log("Theme Ready");

        $(window).on('hashchange', function (e) {
            me.#utils.log("Scroll to Section Ready");

            if (location.hash) {
                if (!me.#utils.scrollToHash(location.hash, null, me.scrollOffset, me.scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });

        $('a').on('click', function (e) {
            let $el = $(this);

            if ($el.attr('href').search('#') === 0) {
                let hash = $el[0].hash;

                if (!me.#utils.scrollToHash(hash, null, me.scrollOffset, me.scrollSpeed)) {
                    e.preventDefault();
                }
            }
        })

        $("#menu-wrapper").mmenu(
            {
                "navbar": {
                    "title": mmtitle,
                },
                // Disabled searchfield in mmenu
                // "navbars": [
                //     {
                //         "position": "bottom",
                //         "content": [
                //             "searchfield"
                //         ]
                //     }
                // ],
                "extensions": [
                    "pagedim-black",
                    "theme-dark",
                    "position-right"
                ],
                "searchfield": {
                    "search": false,
                },
                classNames: {
                    fixedElements: {
                        fixed: "fix",
                        sticky: "stick"
                    }
                }
            }, {
                "searchfield": {
                    "form": {
                        "method": 'GET',
                        "action": homeurl
                    },
                    "input": {
                        "name": 's'
                    }
                }
            }
        );

        //Tab Box JS
        $('.faq_section .faq_section__tab').on('click', function () {
            const num = $(this).attr('data-tab');
            const $parent = $(this).parents('.builder-layout');
            const $tabs = $parent.find('.faq_section');
            const $content = $parent.find('.faq_section__bottom');
            const $tab = $(this).parents('.faq_section__overtab');

            $content.find('.faq_section__content').removeClass('active').addClass('off');
            $content.find('[data-tab="' + num + '"]').addClass('active').removeClass('off');

            $tabs.find('.faq_section__overtab').removeClass('active').addClass('off');
            $tab.addClass('active').removeClass('off');
        });
    }

    __onLoad() {
        const me = this;

        this.#utils.log("Theme Load");

        this.#utils.equalHeight('.image_callout__text', '.builder-layout');
        this.#utils.equalHeight('.title-text', '.builder-layout');
        this.#utils.equalHeight('.graphic_card__title', '.builder-layout');
        this.#utils.equalHeight('.graphic_card__text', '.builder-layout');
        this.#utils.equalHeight('.graphic_card__top', '.builder-layout');
        this.#utils.equalHeight('.rollover-height', '.builder-section-type--rollover');


        this.$header.addClass('fixed');
        this.$main.css('padding-top', this.headerHeight + "px");
        $(window).trigger("resize");

        //Search Bar open/close
        me.#$search.on('click', function () {
            me.$header.toggleClass('js-search-open');
        });

        if (location.hash) {
            this.#utils.log("Scroll to Section Load");

            setTimeout(function () {
                me.#utils.scrollToHash(location.hash, null, me.scrollOffset, me.scrollSpeed);

            }, 300);
        }

        setTimeout(function () {
            me.#inPageNav.events();
        }, 1000);

        setInterval(function () {
            $(window).trigger("resize");
        }, 1000);

        $('a').each(function(){
            if (location.host !== $(this)[0].host){
                $(this).attr('target', '_blank');
            }
        });
    }

    __onResize() {
        this.$main.css('padding-top', this.headerHeight + "px");
    }

    get utils() {
        return this.#utils;
    }

    get headerHeight() {
        if (this.$body.hasClass("admin-bar")) {
            return this.$header.outerHeight() + $("#wpadminbar").outerHeight();
        }

        return this.$header.outerHeight();
    }

    get scrollOffset() {
        let subNav = 0;

        if (this.#inPageNav.isActive) {
            subNav = this.#inPageNav.height;
        }

        return this.#scrollOffset + this.headerHeight + subNav;
    }
}